import { CapoPlugin } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];